import { z } from "zod";
import { NOTIFICATION_EVENT_KEYS } from "../domain";

// Body of POST /api/internal/dispatch-event. The Supabase Edge Function
// cron callers (supabase/functions/_shared/dispatch.ts) post this shape.
// `payload.event_key` is the discriminant; downstream `dispatchEvent()` in
// the notifications service validates the rest of the payload by event type
// — we only do shape gating here so an obviously-broken request gets a 400
// before we even look up notification rules.
export const dispatchEventInputSchema = z.object({
  payload: z
    .object({
      event_key: z.enum(NOTIFICATION_EVENT_KEYS as readonly [string, ...string[]]),
    })
    .passthrough(),
  idempotencyKey: z.string().optional(),
});

export type DispatchEventInput = z.infer<typeof dispatchEventInputSchema>;
